import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,[_c(VCardTitle,[_vm._v("This is about us page")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }